module.exports = __webpack_public_path__ + "img/Flag_of_Canada.6cafa17d.svg";